<template>
    <div v-route-title="'样式模板管理'">
        <div class="database-view">
            <div class="header-view pr">
                <span class="huishouzhan_title">样式模板管理</span>
                <div class="btn-layer">
                    <el-button @click="addRow" type="primary" icon="el-icon-circle-plus-outline">添加样式模板</el-button>
                </div>
            </div>
            <el-form class="yq-search-form" inline :model="searchModel">
                <el-form-item>
                    <el-input v-model="searchModel.id" type="number" style="width: 90px;" placeholder="ID"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-input v-model="searchModel.nameLike" style="width: 120px;" placeholder="样式名称"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-select v-model="searchModel.componentId" placeholder="模板组件" clearable style="width: 120px;">
                        <el-option v-for="item in templates" :key="item.id" :value="item.id" :label="item.name"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <datasource-select v-model="searchModel.datasource"></datasource-select>
                </el-form-item>
                <el-form-item>
                   <el-button type="primary" @click="search">搜索</el-button>
                </el-form-item>
            </el-form>
            <div v-if="data">
                <el-table class="yq-table" :data="data.content" style="width: 100%">
                    <el-table-column
                            label="序号"
                            type="index"
                            :index="indexMethod" width="60">
                    </el-table-column>
                    <el-table-column
                            prop="id"
                            label="ID" width="60">
                    </el-table-column>
                    <el-table-column
                            prop="name"
                            label="样式名称">
                    </el-table-column>
                    <el-table-column
                            label="数据源">
                        <span slot-scope="scope">{{scope.row.datasource.name}}</span>
                    </el-table-column>
                    <el-table-column
                            label="模板组件">
                        <span slot-scope="scope">{{getTemplateNameById(scope.row.componentId)}}</span>
                    </el-table-column>
                    <el-table-column
                            label="操作" width="200">
                        <template slot-scope="scope">
                            <el-popover>
                                <img :src="getTemplateById(scope.row.componentId).preview">
                                <el-link icon="el-icon-view" slot="reference">预览</el-link>
                            </el-popover>
                            <el-link icon="el-icon-edit" @click="editRow(scope.row)" style="margin-left: 5px;">修改</el-link>
                            <el-link icon="el-icon-delete" @click="deleteRow(scope.row)">删除</el-link>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </div>
        <div class="clear"></div>
        <div class="magin10"></div>
        <div class="foot" v-if="data">
            <el-pagination
                    layout="prev, pager, next" background
                    :total="data.totalElements" :current-page="data.number+1"
                    @current-change="fetchData($event)">
            </el-pagination>
        </div>
        <el-dialog v-if="model" :title="model.id?'修改样式模板':'添加样式模板'" :visible.sync="dialogFormVisible" width="850px">
            <el-form ref="form" :model="model" label-width="100px" :rules="rules">
                <el-form-item label="样式名称" prop="name">
                    <el-input v-model="model.name"></el-input>
                </el-form-item>
                <el-form-item label="数据源" prop="datasource">
                    <datasource-select v-model="model.datasource" @input="onDatasourceInput"></datasource-select>
                </el-form-item>
                <el-form-item label="模板组件" prop="componentId">
                    <el-select v-model="model.componentId">
                        <el-option v-for="item in templates" :key="item.id" :value="item.id" :label="item.name"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="模板预览" v-if="model.componentId">
                    <img :src="getTemplateById(model.componentId).preview"/>
                </el-form-item>
                <el-form-item label="组件配置" prop="config" v-if="model.componentId">
                    <view-style-config-input v-model="model.config"
                                             :config-template="getTemplateById(model.componentId).regions"
                                             :datasource="model.datasourceDetails">
                    </view-style-config-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="submitForm">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import viewStyleService from '../service/view-style'
    import dictService from '../service/dict'
    import templates from '../components/templates'
    import DatasourceSelect from '../components/common/DatasourceSelect'
    import ViewStyleConfigInput from '../components/common/ViewStyleConfigInput'
    import datasourceService from '../service/datasource-config'

    export default {
        name: "ViewStyleAdmin",
        components: {DatasourceSelect, ViewStyleConfigInput},
        data() {
            const checkName = (rule, value, callback) => {
                if (value&&this.model.datasource) {
                    const searchParams = {name: value, datasourceId: this.model.datasource.id, page: 0, size: 1}
                    viewStyleService.listViewStyles(searchParams).then(response => {
                        if (response.data.content.length > 0 && this.model.id !== response.data.content[0].id) {
                            callback(new Error('相同数据源的样式名称不能重复'))
                        } else {
                            callback();
                        }
                    }).catch(error => {
                        callback(new Error('校验出错'))
                        throw error
                    })
                } else {
                    callback()
                }
            }
            const checkConfig = (rule, value, callback) => {
                if(value&&this.model.componentId){
                    const template = this.getTemplateById(this.model.componentId)
                    template.validateConfig(value).then(callback).catch(callback)
                } else {
                    callback()
                }
            }
            return {
                templates,
                data: null,
                dialogFormVisible: false,
                searchModel: {
                    id: null,
                    nameLike: null,
                    componentId: null,
                    datasource: null
                },
                searchParams: {
                    id: null,
                    nameLike: null,
                    componentId: null,
                    datasourceId: null
                },
                model: null,
                rules: {
                    name: [
                        {required: true, message: '请输入样式名称', trigger: 'blur'},
                        {min: 1, max: 20, message: '长度在 1 到 20 个字符', trigger: 'blur'},
                        {validator: checkName, trigger: 'blur'}
                    ],
                    datasource: [
                        {required: true, message: '请选择数据源', trigger: 'blur'}
                    ],
                    componentId: [
                        {required: true, message: '请选择模板组件', trigger: 'blur'}
                    ],
                    config: [
                        {required: true, message: '请输入样式配置', trigger: 'blur'},
                        {validator: checkConfig, trigger: 'blur'}
                    ],
                }
            }
        },
        created() {
            this.fetchData(1)
            this.fetchDictTypes()
        },
        methods: {
            async fetchData(page) {
                const params = Object.assign({},this.searchParams,{page: page - 1, size: 10})
                const response = await viewStyleService.listViewStyles(params)
                this.data = response.data
            },
            async fetchDictTypes(){
                const response = await dictService.listAllDictTypes()
                this.dictTypes = response.data
            },
            indexMethod(index) {
                return this.data.number * this.data.size + index + 1
            },
            search(){
                this.searchParams.id = this.searchModel.id
                this.searchParams.nameLike = this.searchModel.nameLike
                this.searchParams.datasourceId = this.searchModel.datasource ? this.searchModel.datasource.id : null
                this.searchParams.componentId = this.searchModel.componentId
                this.fetchData(1)
            },
            addRow() {
                this.model = {
                    name: null,
                    datasource: null,
                    datasourceDetails: null,
                    componentId: null,
                    config: null
                }
                if(this.$refs.form){
                    this.$refs.form.clearValidate()
                }
                this.dialogFormVisible = true
            },
            async getDatasourceDetailsById(id){
                const response = await datasourceService.getDatasourceConfig(id)
                if(response.data.fields){
                    response.data.fields = JSON.parse(response.data.fields)
                }
                return response.data
            },
            async editRow(row) {
                const response = await viewStyleService.getViewStyle(row.id)
                response.data.datasourceDetails = await this.getDatasourceDetailsById(response.data.datasource.id)
                this.model = response.data
                if(this.$refs.form){
                    this.$refs.form.clearValidate()
                }
                this.dialogFormVisible = true
            },
            async onDatasourceInput(value){
                if(value){
                    this.model.datasourceDetails = await this.getDatasourceDetailsById(value.id)
                }else{
                    this.model.datasourceDetails = null
                }
            },
            async submitForm() {
                await this.$refs.form.validate()
                if (this.model.id) {
                    viewStyleService.updateViewStyle(this.model.id,{
                        name: this.model.name,
                        datasourceId: this.model.datasource.id,
                        componentId: this.model.componentId,
                        config: this.model.config
                    }).then(() => {
                        this.dialogFormVisible = false
                        this.fetchData(this.data.number + 1)
                        this.$message({
                            type: 'success',
                            message: '修改成功!'
                        })
                    }).catch(() => {
                        this.$message({
                            type: 'error',
                            message: '修改失败!'
                        })
                    })
                } else {
                    viewStyleService.addViewStyle({
                        name: this.model.name,
                        datasourceId: this.model.datasource.id,
                        componentId: this.model.componentId,
                        config: this.model.config
                    }).then(() => {
                        this.dialogFormVisible = false
                        this.fetchData(this.data.number + 1)
                        this.$message({
                            type: 'success',
                            message: '添加成功!'
                        })
                    }).catch(() => {
                        this.$message({
                            type: 'error',
                            message: '添加失败!'
                        })
                    })
                }
            },
            deleteRow(row) {
                this.$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    viewStyleService.deleteViewStyle(row.id).then(() => {
                        if (this.data.content.length > 1) {
                            this.data.content.splice(this.data.content.indexOf(row), 1)
                        } else {
                            this.fetchData(this.data.number > 0 ? this.data.number : 1)
                        }
                        this.$message({
                            type: 'success',
                            message: '删除成功!'
                        })
                    }).catch(() => {
                        this.$message({
                            type: 'error',
                            message: '删除失败!'
                        })
                    })
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
            },
            getTemplateById(id){
                return templates.find(item=>item.id===id)
            },
            getTemplateNameById(id){
                const template = this.getTemplateById(id)
                return template?template.name:'组件不存在'
            }
        }
    }
</script>
<style scoped>

</style>
